import React, {useRef} from 'react'
import {useSendOtp} from './api/auth'
import {TextInput} from "../../core/components/input";
import Button from "../../core/components/button";
import AuthenticateFooter from "./components/footer";
import handleError from "../../core/helper/handelError";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import __, {currentLanguage} from "../../core/utils/translate/translate";
import Typo from "../../core/components/typo";


export function LoginScreen() {

    const navigate = useNavigate();
    let mobileRef = useRef(null);
    const {mutate: sendOtp, isPending, isError, error, isSuccess, data} = useSendOtp()
    const submitForm = () => {
        if (!mobileRef.current.getValue()) {
            toast.error(__("Please enter your mobile number!"))
            mobileRef.current.focus()
            return;
        }

        sendOtp({mobile: mobileRef.current.getValue()}, {
            onSuccess: (data) => {
                navigate(`/authenticate/otp/${mobileRef.current.getValue()}/${data?.data?.otpToken}`)
            },
            onError: (error) => {
                handleError(error)
            }
        })
    }

    return (
        <>
            <TextInput
                name={__("Mobile number")}
                label={__("Enter your mobile number.")}
                placeholder="09xx-xxx-xxxx"
                inputMode="tel"
                dir="ltr"
                autoFocus
                maxLength={11}
                rules={[
                    {rule: "size", cond: 11},
                    {rule: "startsWith", cond: "09"},
                ]}
                required={true}
                ref={mobileRef}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        submitForm();
                    }
                }}
            />
            <div>
                <Typo
                    as="span"
                    size="xs"
                    weight="semi-bold"
                    type="accent"
                    className={'mx-1'}
                    onClick={() => navigate('/authenticate/passwd')}
                >
                    {__("Login by password")}
                </Typo>

            </div>

            <div className="flex-1"/>
            <div className="flex flex-col items-center gap-2">
                <Button onClick={submitForm} isLoading={isPending}>
                    {__("Continue")}
                </Button>
            </div>
            <AuthenticateFooter loginByGoogle={currentLanguage() === 'ar-sa'}/>
        </>
    )
}


